export default __webpack_public_path__ + "static/media/Search.b92224fc.svg";